import React, { Suspense } from "react";
import { lazyWithRetry } from "../utils/lazyWithRetry";
import { LazyFallback } from "../components/LazyFallback";

// Raw thunk for background prefetch (must not go through lazyWithRetry —
// a silent prefetch failure must never reload the page).
export const loadProject = () => import("./Project");

const Project = lazyWithRetry(() =>
  loadProject().then((m) => ({ default: m.Project })),
);

export const ProjectLazy = () => (
  <Suspense fallback={<LazyFallback />}>
    <Project />
  </Suspense>
);
